import React from 'react'
import { graphql } from 'gatsby'
import SEO from '../components/SEO'
import Layout from '../components/layout'
import BlogList from '../templates/blogList'
import {Button,Modal} from 'react-bootstrap'
import {ReactModal} from 'react-modal'




const IndexPage = ({ data }) => (
  
  <Layout>
    <SEO
      title="Blog Posts by Chintan Agrawal"
      description="My vision for this blog is to help new developers understand Big Data services provided by AWS and build efficient ETL solutions.  "
    />
    <Modal/>
    <BlogList data={data} templateTitle="Articles" />
  </Layout>
)
// function IndexPage({data}) {
//   const [modalShow, setModalShow] = React.useState(false);
//   return (
    // <Layout>
    // <SEO
    //   title="Blog Posts by Chintan Agrawal"
    //   description="My vision for this blog is to help new developers understand Big Data services provided by AWS and build efficient ETL solutions.  "
    // />
    // <BlogList data={data} templateTitle="Articles" />
    // </Layout>
//   )
// }



export default IndexPage

export const query = graphql`
  query {
    allMdx(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "MMM DD, YYYY")
            info
            tags
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`
